import ExternalLink from './external_link';

export default ExternalLink;
